import { useEffect, useRef, useState } from 'react'

export function useScrollDirectionNew(debounceTime = 150) {
  const [hasScrolled, setHasScrolled] = useState(false)
  const [isScrollingUp, setIsScrollingUp] = useState(false)
  const lastScrollY = useRef(0)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const handleScroll = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)

      timeoutRef.current = setTimeout(() => {
        const currentScrollY = window.scrollY
        const hasScrolledNow = currentScrollY > 10
        const isScrollingUpNow = currentScrollY > lastScrollY.current

        setHasScrolled(hasScrolledNow)
        // Chỉ thay đổi trạng thái nếu có sự khác biệt rõ ràng
        if (isScrollingUpNow !== isScrollingUp) {
          setIsScrollingUp(isScrollingUpNow)
        }

        lastScrollY.current = currentScrollY
      }, debounceTime)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [debounceTime, isScrollingUp])

  return { hasScrolled, isScrollingUp }
}
